'use client';

import { InfoIcon, ReportIcon, TriangleIcon } from '@insta-club/components/icons';

interface PageStatsData {
    followers: number;
    followings: number;
    eng: number;
    media: number;
    followers_diff: number;
    followings_diff: number;
    eng_diff: string | number;
    media_diff: number;
}

interface Props {
    data: PageStatsData;
    startDate: string;
    endDate: string;
}

const PageStatsTable = ({ data, startDate, endDate }: Props) => {
    const tableRows = [
        {
            label: 'Follower',
            startValue: data.followers,
            endValue: data.followers + data.followers_diff,
            diff: data.followers_diff,
            isPercentage: false
        },
        {
            label: 'Following',
            startValue: data.followings,
            endValue: data.followings + data.followings_diff,
            diff: data.followings_diff,
            isPercentage: false
        },
        {
            label: 'Engagement Rate',
            startValue: data.eng,
            endValue: data.eng + parseFloat(data.eng_diff.toString()),
            diff: parseFloat(data.eng_diff.toString()),
            isPercentage: true,
        },
        {
            label: 'Media',
            startValue: data.media,
            endValue: data.media + data.media_diff,
            diff: data.media_diff,
            isPercentage: false
        }
    ];

    const formatValue = (value: number, isPercentage: boolean) => {
        if (isPercentage) {
            return `${value?.toFixed(1)}%`;
        }
        return value?.toLocaleString();
    };

    const getDiffColor = (diff: number) => {
        return diff >= 0 ? 'text-green-400' : 'text-red-400';
    };

    const getTriangleRotation = (diff: number) => {
        return diff >= 0 ? '' : 'rotate-180';
    };

    return (
        <div className='flex flex-col'>
            <div className='mb-4'>
                <h4 className='flex items-center text-base font-semibold text-gray-900'>
                    <ReportIcon className='mb-1 ml-1 text-gray-600' />
                    گزارش آمار پیج
                </h4>

                <p className='text-sm leading-relaxed font-medium text-gray-600'>
                    در این قسمت شما میتوانید آمار پیج خود را در ابتدا و انتها برنامه مشاهده کنید.
                </p>
            </div>

            <table className='w-full table-fixed border-collapse'>
                <thead>
                    <tr className='bg-primary-400 text-white'>
                        <th className='w-1/3 p-3 text-right'></th>
                        <th className='w-1/3 p-3 text-center font-semibold'>{startDate}</th>
                        <th className='w-1/3 p-3 text-center font-semibold'>{endDate}</th>
                        <th className='w-1/3 p-3 text-center font-semibold'></th>
                    </tr>
                </thead>

                <tbody className='divide-y divide-gray-200 rounded-md bg-white shadow-sm'>
                    {tableRows.map((row) => (
                        <tr key={row.label}>
                            <td className='p-3 text-center text-sm font-medium'>{row.label}</td>
                            <td
                                className='p-3 text-center text-xs font-medium text-gray-600'
                                style={{ fontFamily: 'Poppins' }}
                            >
                                {formatValue(row.startValue, row.isPercentage)}
                            </td>
                            <td className='p-3 text-xs font-medium text-gray-600' style={{ fontFamily: 'Poppins' }}>
                                <div className='flex items-center justify-center'>
                                    {formatValue(row.endValue, row.isPercentage)}
                                </div>
                            </td>
                            <td className='p-3 text-xs font-medium text-gray-600' style={{ fontFamily: 'Poppins' }}>
                                <div className='flex items-center justify-center'>
                                    {formatValue(Math.abs(row.diff), row.isPercentage)}
                                    <TriangleIcon
                                        className={`mr-1 ${getTriangleRotation(row.diff)} ${getDiffColor(row.diff)}`}
                                        width={10}
                                    />
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div className='mt-3 flex items-start gap-1'>
                <InfoIcon className='relative top-0.5 shrink-0 text-gray-600' />
                <p className=' text-sm leading-relaxed font-medium text-gray-600'>
                    در این قسمت شما میتوانید آمار پیج خود را در ابتدا و انتها برنامه مشاهده کنید.
                </p>
            </div>
        </div>
    );
};

export default PageStatsTable;

